<template>
  <div class="d-flex align-center">
    <v-icon :color="iconColor">{{ iconName }}</v-icon>
    <span class="ml-1">{{ label }}</span>
  </div>
</template>

<script>
import { AiReportStatus as StatusEnum } from "@/utilities/enums";

export default {
  name: "AiReportStatus",
  props: {
    status: {
      type: Number,
      required: true,
    },
  },
  computed: {
    iconName() {
      return (
        {
          1: "mdi-clock-outline",
          2: "mdi-send-outline",
          3: "mdi-check-circle-outline",
          4: "mdi-alert-circle-outline",
        }[this.status] || "mdi-help-circle"
      );
    },
    iconColor() {
      return (
        {
          1: "blue",
          2: "orange",
          3: "green",
          4: "red",
        }[this.status] || "grey"
      );
    },
    label() {
      return StatusEnum.codeToLabel(this.status);
    },
  },
};
</script>
